import React from 'react';
import { ReactFlowProvider } from 'reactflow';
import WorkflowBuilder from '../Views/Pages/WorkflowBuilder';

const WorkflowBuilderWrapper: React.FC = () => {
  return (
    <ReactFlowProvider>
      <WorkflowBuilder />
    </ReactFlowProvider>
  );
};

export default WorkflowBuilderWrapper;
